(()=>{
  const root=window.Shopify?.routes?.root||'/';
  const offerEnd=Date.parse('2026-10-15T20:59:59Z');
  let busy=false;
  const money=(cents,currency)=>new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:currency||'USD'}).format(cents/100);
  const config=()=>document.querySelector('cart-drawer')?.dataset||{};
  const addonIds=()=>[Number(config().slShippingId),Number(config().slMysteryId)].filter(Boolean);
  const labels=()=>JSON.parse(document.querySelector('[data-sl-cart-labels]')?.textContent||'{}');
  function sections(){
    return [...new Set(['cart-drawer','cart-icon-bubble',...['main-cart-items','main-cart-footer'].map(id=>document.getElementById(id)?.dataset.id).filter(Boolean)])];
  }
  async function request(action,body){
    const response=await fetch(root+'cart/'+action+'.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({...body,sections:sections(),sections_url:window.location.pathname})});
    const cart=await response.json();
    if(!response.ok)throw new Error(cart.description||cart.message||labels().error);
    return cart;
  }
  async function readCart(){
    const response=await fetch(root+'cart.js',{headers:{'Accept':'application/json'},cache:'no-store'});
    if(!response.ok)throw new Error(labels().error);
    return response.json();
  }
  function discounts(cart,quantity){
    const keep=(cart.discount_codes||[]).filter(x=>!/^SACRED[23]$/i.test(x.code)).map(x=>x.code);
    if(Date.now()<offerEnd&&quantity>=2)keep.push(quantity>=3?'SACRED3':'SACRED2');
    return keep.join(',');
  }
  const lampQuantity=cart=>cart.items.filter(x=>x.variant_id===Number(config().slLampId)).reduce((n,x)=>n+x.quantity,0);
  function lock(locked){
    document.querySelectorAll('cart-drawer,cart-items').forEach(container=>{
      container.setAttribute('aria-busy',String(locked));
      container.querySelectorAll('.quantity__button,.quantity__input,cart-remove-button button,[data-sl-cart-addon],[name="checkout"]').forEach(control=>{
        if(locked){control.dataset.slDisabled=String(control.disabled);control.disabled=true;}
        else if(control.dataset.slDisabled!==undefined){control.disabled=control.dataset.slDisabled==='true';delete control.dataset.slDisabled;}
      });
    });
  }
  function clearLoading(){
    document.querySelectorAll('.cart__items--disabled').forEach(x=>x.classList.remove('cart__items--disabled'));
    document.querySelectorAll('cart-drawer .loading-overlay,cart-items .loading-overlay').forEach(x=>x.classList.add('hidden'));
    if(!document.querySelector('cart-drawer.active'))document.body.classList.remove('overflow-hidden');
  }
  function closeDrawer(){
    const drawer=document.querySelector('cart-drawer');
    if(drawer?.close)drawer.close();
    else {drawer?.classList.remove('active');document.body.classList.remove('overflow-hidden');}
    clearLoading();
  }
  function render(cart,open=false){
    const drawer=document.querySelector('cart-drawer');
    const wasOpen=drawer?.classList.contains('active');
    if(typeof removeTrapFocus==='function')removeTrapFocus();
    const html=cart.sections?.['cart-drawer'];
    if(drawer&&html){
      const parsed=new DOMParser().parseFromString(html,'text/html').querySelector('#CartDrawer');
      if(!parsed)throw new Error(labels().error);
      document.getElementById('CartDrawer').innerHTML=parsed.innerHTML;
      drawer.classList.toggle('is-empty',cart.item_count===0);
    }
    for(const id of ['main-cart-items','main-cart-footer']){
      const target=document.getElementById(id);
      const section=target?.dataset.id;
      if(!target||!cart.sections?.[section])continue;
      const parsed=new DOMParser().parseFromString(cart.sections[section],'text/html');
      if(id==='main-cart-items'){
        const current=target.closest('cart-items');
        const incoming=parsed.querySelector('cart-items');
        if(current&&incoming){current.innerHTML=incoming.innerHTML;current.className=incoming.className;current.dataset.subtotal=String(cart.total_price);}
      }else{
        const incoming=parsed.getElementById(id);
        if(incoming){target.innerHTML=incoming.innerHTML;target.className=incoming.className;}
      }
    }
    document.querySelectorAll('[data-sl-cart-count]').forEach(x=>x.textContent=cart.item_count);
    document.querySelectorAll('[data-sl-cart-addon]').forEach(x=>x.checked=cart.items.some(item=>item.variant_id===Number(x.value)));
    clearLoading();
    if(drawer&&(open||wasOpen)){
      drawer.open?.(document.getElementById('cart-icon-bubble'));
      const dialog=drawer.querySelector('.drawer__inner');
      const focus=dialog?.querySelector('.drawer__close');
      if(dialog&&focus&&typeof trapFocus==='function')trapFocus(dialog,focus);
    }
    document.dispatchEvent(new CustomEvent('sacred:cart-updated',{detail:{item_count:cart.item_count,total_price:cart.total_price}}));
  }
  async function transaction(work){
    if(busy)return;
    busy=true;lock(true);
    document.querySelectorAll('#cart-errors,#CartDrawer-CartErrors').forEach(x=>x.textContent='');
    try {await work();}
    catch(error){
      try{render(await request('update',{updates:{}}));}catch{}
      document.querySelectorAll('#cart-errors,#CartDrawer-CartErrors').forEach(x=>x.textContent=error.message||labels().error);
      throw error;
    }finally{busy=false;lock(false);clearLoading();}
  }
  async function updateLine(key,quantity){
    return transaction(async()=>{
      const before=await readCart();
      const item=before.items.find(x=>x.key===key);
      if(!item)return;
      const updates={[key]:quantity};
      const remaining=before.items.map(x=>({...x,quantity:updates[x.key]??x.quantity})).filter(x=>x.quantity>0);
      if(quantity===0&&!remaining.some(x=>!addonIds().includes(x.variant_id))){
        remaining.filter(x=>addonIds().includes(x.variant_id)).forEach(x=>updates[x.key]=0);
      }
      const lamp=remaining.filter(x=>x.variant_id===Number(config().slLampId)).reduce((n,x)=>n+x.quantity,0);
      const cart=await request('update',{updates,discount:discounts(before,lamp)});
      render(cart);
    });
  }
  async function toggleAddon(input){
    const id=Number(input.value),checked=input.checked;
    return transaction(async()=>{
      const before=await readCart();
      const matches=before.items.filter(x=>x.variant_id===id);
      let cart;
      if(checked&&!matches.length){
        await request('add',{items:[{id,quantity:1}]});
        const current=await readCart();
        cart=await request('update',{updates:{},discount:discounts(current,lampQuantity(current))});
      }else{
        const updates={};matches.forEach((x,i)=>updates[x.key]=checked&&i===0?1:0);
        cart=await request('update',{updates,discount:discounts(before,lampQuantity(before))});
      }
      render(cart);
    });
  }
  async function addLamp(lines,addons){
    return transaction(async()=>{
      const before=await readCart();
      const items=[...lines,...addons.filter(addon=>!before.items.some(x=>x.variant_id===addon)).map(id=>({id,quantity:1}))];
      await request('add',{items});
      const current=await readCart();
      const updates={};
      addonIds().forEach(id=>current.items.filter(x=>x.variant_id===id).forEach((x,i)=>{if(i||x.quantity!==1)updates[x.key]=i?0:1;}));
      const cart=await request('update',{updates,discount:discounts(current,lampQuantity(current))});
      render(cart,true);
    });
  }
  document.addEventListener('click',event=>{
    const target=event.target instanceof Element?event.target:null;
    if(!target)return;
    if(target.closest('cart-drawer .drawer__close,cart-drawer #CartDrawer-Overlay')){event.preventDefault();event.stopImmediatePropagation();closeDrawer();return;}
    const remove=target.closest('cart-remove-button');
    if(remove){
      event.preventDefault();event.stopImmediatePropagation();
      const key=remove.closest('[data-sl-line-key]')?.dataset.slLineKey;
      if(key)updateLine(key,0).catch(()=>{});
    }
  },true);
  document.addEventListener('change',event=>{
    const input=event.target;
    if(!(input instanceof HTMLInputElement))return;
    if(input.matches('[data-sl-cart-addon]')){event.stopImmediatePropagation();toggleAddon(input).catch(()=>{});return;}
    if(input.matches('cart-drawer .quantity__input,cart-items .quantity__input')){
      event.stopImmediatePropagation();
      const key=input.closest('[data-sl-line-key]')?.dataset.slLineKey;
      const value=Number(input.value);
      if(key&&Number.isInteger(value)&&value>=0)updateLine(key,value).catch(()=>{});
    }
  },true);
  function init(){
    document.querySelectorAll('[data-sl-purchase]').forEach(panel=>{
      if(panel.dataset.initialized)return;
      panel.dataset.initialized='true';panel.id='SacredPurchase';
      const form=panel.querySelector('form'),button=panel.querySelector('[data-sl-submit]'),message=panel.querySelector('[data-sl-message]');
      const text=JSON.parse(panel.querySelector('[data-sl-labels]').textContent);
      const selected=()=>form.querySelector('input[name="quantity"]:checked');
      function refresh(){
        const selectedCard=selected().closest('[data-sl-bundle-card]');
        const addons=form.querySelector('[data-sl-addons]');
        if(selectedCard&&addons&&addons.parentElement!==selectedCard)selectedCard.append(addons);
        const valid=Date.now()<offerEnd,unit=Number(panel.dataset.price),q=Number(selected().value);
        let total=(unit-Math.floor(unit*(valid?(q===3?.15:q===2?.1:0):0)))*q;
        form.querySelectorAll('[data-sl-addon]:checked').forEach(x=>total+=Number(x.dataset.price));
        panel.querySelector('[data-sl-order-total]').textContent=money(total,panel.dataset.currency);
        panel.querySelectorAll('[data-sl-bundle-total]').forEach(x=>{
          const qty=Number(x.closest('label').querySelector('input[type=radio]').value);
          x.textContent=money((unit-Math.floor(unit*(valid?(qty===3?.15:qty===2?.1:0):0)))*qty,panel.dataset.currency);
        });
        if(!valid)panel.querySelectorAll('[data-sl-saving]').forEach(x=>x.hidden=true);
      }
      form.addEventListener('change',refresh);refresh();
      const timer=panel.querySelector('[data-sl-countdown]');
      if(timer){
        const tick=()=>{
          const seconds=Math.max(0,Math.floor((offerEnd-Date.now())/1000));
          if(!seconds){timer.hidden=true;refresh();clearInterval(interval);return;}
          for(const [key,value] of [['hours',Math.floor(seconds/3600)],['minutes',Math.floor(seconds%3600/60)],['seconds',seconds%60]])timer.querySelector('[data-sl-'+key+']').textContent=String(value).padStart(2,'0');
        };
        const interval=setInterval(tick,1000);tick();
      }
      form.addEventListener('submit',async event=>{
        event.preventDefault();if(button.disabled||busy)return;
        button.disabled=true;panel.querySelector('[data-sl-button-label]').textContent=text.adding;message.textContent='';
        try{
          const qty=Number(selected().value),card=selected().closest('[data-sl-bundle-card]');
          const picks=card?Array.from(card.querySelectorAll('[data-sl-unit] input:checked')).map(x=>Number(x.value)):[];
          const counts={};(picks.length===qty?picks:Array(qty).fill(Number(form.querySelector('input[name="id"]').value))).forEach(v=>counts[v]=(counts[v]||0)+1);
          await addLamp(Object.entries(counts).map(([id,quantity])=>({id:Number(id),quantity})),Array.from(form.querySelectorAll('[data-sl-addon]:checked')).map(x=>Number(x.value)));
          message.textContent=text.added;
        }catch(error){message.textContent=error.message||text.error;}
        finally{button.disabled=false;panel.querySelector('[data-sl-button-label]').textContent=text.add;}
      });
      const sticky=panel.querySelector('[data-sl-sticky]');
      if(sticky&&'IntersectionObserver' in window)new IntersectionObserver(entries=>sticky.hidden=entries[0].isIntersecting||button.disabled).observe(button);
      panel.querySelector('[data-sl-sticky-buy]')?.addEventListener('click',()=>{panel.scrollIntoView({behavior:'smooth',block:'start'});button.focus({preventScroll:true});});
    });
    document.querySelectorAll('[data-sl-scroll]').forEach(link=>{
      if(link.dataset.bound)return;link.dataset.bound='true';
      link.addEventListener('click',event=>{event.preventDefault();document.querySelector('[data-sl-purchase]')?.scrollIntoView({behavior:'smooth',block:'start'});});
    });
    document.querySelectorAll('[data-sl-announcement]').forEach(x=>x.hidden=Date.now()>=offerEnd);
    clearLoading();
  }
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init):init();
  document.addEventListener('shopify:section:load',init);
})();
